import { Link } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

/**
 * Mega-Sprint B · Empty states enriquecidos.
 * Uso:
 *   <EmptyState
 *     icon={Calendar}
 *     title="Aún no hay reservas"
 *     description="Crea tu primera reserva o comparte tu link público."
 *     primaryCta={{ to: "/calendar/new", label: "Nueva reserva" }}
 *     secondaryCta={{ href: "https://ayuda.example.com/reservas", label: "Ver tutorial" }}
 *     tip="Tip: configura tus servicios en Catálogo antes de aceptar reservas."
 *   />
 */
export function EmptyState({ icon: Icon = Sparkle, title, description, primaryCta, secondaryCta, tip, testId }) {
  return (
    <div className="ag-card p-10 text-center max-w-md mx-auto" data-testid={testId || "empty-state"}>
      <div className="mx-auto w-14 h-14 grid place-items-center rounded-full bg-[var(--ag-gold)]/15 text-[var(--ag-gold)] mb-4">
        <Icon size={28} weight="duotone" />
      </div>
      <h3 className="font-display font-black text-xl tracking-tighter">{title}</h3>
      {description && <p className="text-sm text-[var(--ag-text-dim)] mt-2 max-w-sm mx-auto">{description}</p>}
      {(primaryCta || secondaryCta) && (
        <div className="mt-5 flex flex-wrap gap-2 justify-center">
          {primaryCta && (
            primaryCta.to
              ? <Link to={primaryCta.to} className="ag-btn-gold h-10 px-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-wider font-bold" data-testid={`${testId || "empty-state"}-primary`}>
                  {primaryCta.label} <ArrowRight size={12} weight="bold" />
                </Link>
              : <button onClick={primaryCta.onClick} className="ag-btn-gold h-10 px-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-wider font-bold" data-testid={`${testId || "empty-state"}-primary`}>
                  {primaryCta.label} <ArrowRight size={12} weight="bold" />
                </button>
          )}
          {secondaryCta && (
            secondaryCta.to
              ? <Link to={secondaryCta.to} className="h-10 px-5 inline-flex items-center text-xs uppercase tracking-wider font-bold border border-[var(--ag-border)] rounded-sm hover:bg-[var(--ag-midnight-soft)]" data-testid={`${testId || "empty-state"}-secondary`}>{secondaryCta.label}</Link>
              : <a href={secondaryCta.href} target={secondaryCta.external ? "_blank" : undefined} rel="noopener noreferrer" className="h-10 px-5 inline-flex items-center text-xs uppercase tracking-wider font-bold border border-[var(--ag-border)] rounded-sm hover:bg-[var(--ag-midnight-soft)]" data-testid={`${testId || "empty-state"}-secondary`}>{secondaryCta.label}</a>
          )}
        </div>
      )}
      {tip && (
        <div className="mt-5 text-[11px] text-[var(--ag-gold)] inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[var(--ag-gold)]/10 border border-[var(--ag-gold)]/30">
          <Sparkle size={11} weight="fill" /> {tip}
        </div>
      )}
    </div>
  );
}
